import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';

import { RangeKey } from '@common/enum';
import { DatesService } from '@common/services';

@Component({
    selector: 'aa-range-selector',
    templateUrl: './range-selector.component.html',
    styleUrls: [
        './range-selector.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RangeSelectorComponent implements OnInit
{
    private intervalId: any;
    @Input() ranges: RangeKey[];
    @Input() theme: string = 'white';
    @Input() direction: 'top' | 'bottom' = 'bottom';
    @Input() selected: number = 0;
    @Output() selectRange: EventEmitter<RangeKey> = new EventEmitter<RangeKey>();
    public open: boolean = false;
    public width: number = 160;
    public select: RangeKey;
    public displayedPeriod: string;

    constructor ( private datesService: DatesService)
    {
    }

    ngOnInit ()
    {
        this.select = this.ranges[this.selected];
        this.adjustDisplayedPeriod(this.ranges[this.selected]);
    }

    onClickOpen ()
    {
        this.open = !this.open;
        if (this.open)
        {
            clearTimeout(this.intervalId);
            this.intervalId = setTimeout(() => this.open = false, 5000);
        }
    }

    onRangeChanged (rangeKey: RangeKey)
    {
        this.selectRange.emit(rangeKey);
        this.select = rangeKey;
        this.open = false;
        this.adjustDisplayedPeriod(rangeKey);
    }

    private adjustDisplayedPeriod (rangeKey: RangeKey): void
    {
        const range = this.datesService.preRangeDates(rangeKey);

        this.displayedPeriod = this.datesService.displayRangePeriod(range.since, range.until);
    }
}
